import React, {useEffect, useRef, useState} from 'react';
import moment from "moment";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {classNames} from "primereact/utils";
import {InputText} from "primereact/inputtext";
import {Checkbox} from "primereact/checkbox";
import {Calendar} from "primereact/calendar";
import {setChangedScheduler, setCompanyField, toggleCampaignDayActive, updateCampaignDayTime} from "../../../../redux/actions/actions";
const CampaignDaysWeekSchedule = (props: any) => {
    moment.suppressDeprecationWarnings = true;
    const dispatch = useAppDispatch();
    // @ts-ignore
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    // @ts-ignore
    const archiveTableToggle = useAppSelector(state => state.CompaniesListReducer.archiveTableToggle);
    // @ts-ignore
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData);
    // @ts-ignore
    const campaignScheduler = companiesData?.scheduler;
    const statusDone = companiesData?.campaign?.statusId === 6;

    const [updatedScheduler, setUpdatedScheduler] = useState<any>({
        "days": [
            {
                "label": "Понеділок",
                "dayOfWeek": 1
            },
            {
                "label": "Вівторок",
                "dayOfWeek": 2
            },
            {
                "label": "Середа",
                "dayOfWeek": 3
            },
            {
                "label": "Четвер",
                "dayOfWeek": 4
            },
            {
                "label": "П'ятниця",
                "dayOfWeek": 5
            },
            {
                "label": "Субота",
                "dayOfWeek": 6
            },
            {
                "label": "Неділя",
                "dayOfWeek": 0
            }
        ]
    });

    const previousTimeValues = useRef<{[key: string]: {start?: string, end?: string}}>({});

    const weekdayField = [
        {label: 'Понеділок', dayOfWeek: 1},
        {label: 'Вівторок', dayOfWeek: 2},
        {label: 'Середа', dayOfWeek: 3},
        {label: 'Четвер', dayOfWeek: 4},
        {label: 'П\'ятниця', dayOfWeek: 5},
        {label: 'Субота', dayOfWeek: 6},
        {label: 'Неділя', dayOfWeek: 0}
    ];

    useEffect(() => {
        if (campaignScheduler && campaignScheduler?.days) {
            const updatedDays = weekdayField.map(weekday => {
                const matchingDay = campaignScheduler?.days?.find((day: { dayOfWeek: number; }) => day.dayOfWeek === weekday.dayOfWeek);

                if (matchingDay) {
                    return {...weekday, ...matchingDay};
                }

                return weekday;
            });

            setUpdatedScheduler({...campaignScheduler, days: updatedDays});
        } else {
        }
    }, [campaignScheduler]);

    const isValidDate = (value: any) => {
        const format = 'MM/DD/YYYY';
        return moment(value, format, true).isValid();
    };

    const handleDateChange = (date: any) => {
        return moment(date).format('MM/DD/YYYY HH:mm:ss');
    };

    const transformToDate = (dateString: any) => {
        return new Date(moment(dateString).format('MM/DD/YYYY HH:mm:ss'));
    }

    const createDefaultTime = (isStart: boolean) => {
        const today = new Date();
        if (isStart) {
            today.setHours(0, 0, 0, 0);
        } else {
            today.setHours(23, 59, 0, 0);
        }
        return handleDateChange(today);
    };

    const getTimeValue = (dayOfWeek: number, type: 'start' | 'end') => {
        const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === dayOfWeek);
        if (dayData && dayData[type]) {
            return transformToDate(dayData[type]);
        }
        return null;
    };

    const handleTimeFocus = (dayOfWeek: number, type: 'start' | 'end') => {
        const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === dayOfWeek);
        if (dayData && dayData[type]) {
            if (!previousTimeValues.current[dayOfWeek]) {
                previousTimeValues.current[dayOfWeek] = {};
            }
            previousTimeValues.current[dayOfWeek][type] = dayData[type];
            dispatch(updateCampaignDayTime(dayOfWeek, null, type));
        }
    };

    const handleTimeBlur = (dayOfWeek: number, type: 'start' | 'end') => {
        const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === dayOfWeek);
        if (!dayData || !dayData[type]) {
            const previousValue = previousTimeValues.current[dayOfWeek]?.[type];
            const valueToSet = previousValue || createDefaultTime(type === 'start');
            dispatch(updateCampaignDayTime(dayOfWeek, valueToSet, type));
        }
    };

    return (
        <div className="grid p-fluid">
            <div className="field col-12 md:col-12">
                <label htmlFor="icon" className="block field">Дата запуску</label>
                <Calendar
                    className={classNames('mt-2 col-6 pl-0', {'p-invalid': errorFields?.startDate && companiesData?.scheduler?.typeScheduler === 401})}
                    value={companiesData?.scheduler?.startDate ? transformToDate(companiesData?.scheduler?.startDate) : transformToDate(props.startDate)}
                    onChange={(e: any) => {
                        if (isValidDate(e.value)) {
                            dispatch(setChangedScheduler(true));
                            dispatch(setCompanyField({section: 'scheduler', fieldName: 'startDate', value: handleDateChange(e.value)}));
                        }
                    }}
                    onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;

                        const digits = input.value.replace(/\D/g, "").slice(0, 8); // ddMMyyyy

                        const dd = digits.slice(0, 2);
                        const mm = digits.slice(2, 4);
                        const yyyy = digits.slice(4, 8);

                        const display =
                            (dd || "") +
                            (digits.length > 2 ? "/" + mm : "") +
                            (digits.length > 4 ? "/" + yyyy : "");

                        const newCaret =
                            digits.length +
                            (digits.length > 2 ? 1 : 0) +
                            (digits.length > 4 ? 1 : 0);

                        if (input.value !== display) {
                            input.value = display;
                            input.setSelectionRange(newCaret, newCaret);
                        }

                        if (digits.length === 8) {
                            const day = parseInt(dd, 10);
                            const month = parseInt(mm, 10) - 1; // 0-based
                            const year = parseInt(yyyy, 10);
                            const parsed = new Date(year, month, day);

                            const valid =
                                !isNaN(parsed.getTime()) &&
                                parsed.getDate() === day &&
                                parsed.getMonth() === month &&
                                parsed.getFullYear() === year;

                            if (valid && isValidDate(parsed)) {
                                dispatch(setChangedScheduler(true));
                                dispatch(setCompanyField({section: 'scheduler', fieldName: 'startDate', value: handleDateChange(parsed)}));
                            }
                        }
                    }}
                    onFocus={(e: any) => {
                        e.target.value = "";
                    }}
                    onBlur={(e: any) => {
                        const digits = e.target.value.replace(/\D/g, "");
                        if (digits.length !== 8) {
                            e.target.value = "";
                            const originalValue = companiesData?.scheduler?.startDate ? transformToDate(companiesData?.scheduler?.startDate) : transformToDate(props.startDate);
                            if (originalValue) {
                                e.target.value = originalValue.toLocaleDateString('en-GB');
                            }
                        }
                    }}
                    minDate={new Date()}
                    maxDate={new Date(2030, 11, 31)}
                    dateFormat="dd/mm/yy"
                    placeholder="дд/мм/рр"
                    disabled={!archiveTableToggle || statusDone || !editType}
                />
            </div>
            <div className="field col-12 md:col-6">
                <label className={classNames('mb-3 font-bold', {'p-error': errorFields?.scheduler || errorFields?.scheduler})}>Розклад дзвінків</label>
                {updatedScheduler?.days?.map((field: any, index: number) => (
                    <div className="field col-12 md:col-12 mb-0 p-0" key={index}>
                        <div className="grid align-items-center">
                            <div className="col-12 md:col-4">
                                <InputText type="text" value={field.label} className="opacity-100 w-full" placeholder={field.label} disabled/>
                            </div>
                            <div className="col-2 md:col-2 flex justify-content-center">
                                <Checkbox
                                    disabled={!archiveTableToggle || !editType}
                                    className={classNames('opacity-100', {'p-invalid': errorFields?.scheduler && !updatedScheduler?.days})}
                                    checked={!!campaignScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}
                                    onChange={(e) => {
                                        dispatch(toggleCampaignDayActive(field.dayOfWeek, e.checked));
                                        if (e.checked) {
                                            const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === field.dayOfWeek);
                                            if (!dayData?.start) {
                                                dispatch(updateCampaignDayTime(field.dayOfWeek, createDefaultTime(true), 'start'));
                                            }
                                            if (!dayData?.end) {
                                                dispatch(updateCampaignDayTime(field.dayOfWeek, createDefaultTime(false), 'end'));
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-6 md:col-3 flex align-items-center">
                                <div className="mr-2">
                                    <label>З</label>
                                </div>
                                <Calendar
                                    key={`start-${field.dayOfWeek}-${!!campaignScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}`}
                                    className={classNames('opacity-100', {'p-invalid': errorFields?.scheduler && !updatedScheduler?.days})}
                                    disabled={!archiveTableToggle || !editType || !campaignScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}
                                    value={getTimeValue(field.dayOfWeek, 'start')}
                                    onChange={e => {
                                        if (isValidDate(e.target.value)) {
                                            const newTime = handleDateChange(e.target.value);
                                            dispatch(updateCampaignDayTime(field.dayOfWeek, newTime, 'start'));
                                        }
                                    }}
                                    placeholder="00:00"
                                    timeOnly
                                    hourFormat="24"
                                    onFocus={() => handleTimeFocus(field.dayOfWeek, 'start')}
                                    onBlur={() => handleTimeBlur(field.dayOfWeek, 'start')}
                                    onInput={(e: any) => {
                                        const input = e.target as HTMLInputElement;

                                        let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                        const HH = digits.slice(0, 2);
                                        const MM = digits.slice(2, 4);

                                        const display = HH + (digits.length > 2 ? ":" + MM : "");

                                        if (input.value !== display) {
                                            const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                            input.value = display;
                                            input.setSelectionRange(caret, caret);
                                        }

                                        if (digits.length === 4) {
                                            const h = parseInt(HH, 10);
                                            const m = parseInt(MM, 10);
                                            const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                            if (valid) {
                                                const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === field.dayOfWeek);
                                                const base = dayData?.start ? new Date(dayData.start) : new Date();
                                                base.setHours(h, m, 0, 0);
                                                const newTime = handleDateChange(base);
                                                dispatch(updateCampaignDayTime(field.dayOfWeek, newTime, 'start'));
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-6 md:col-3 flex align-items-center">
                                <div className="mr-2">
                                    <label>По</label>
                                </div>
                                <Calendar
                                    key={`end-${field.dayOfWeek}-${!!campaignScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}`}
                                    disabled={!archiveTableToggle || !editType || !campaignScheduler?.days?.find((day: { dayOfWeek: any; }) => day.dayOfWeek === field.dayOfWeek)}
                                    className={classNames('opacity-100', {'p-invalid': errorFields?.scheduler && !updatedScheduler?.days})}
                                    value={getTimeValue(field.dayOfWeek, 'end')}
                                    onChange={e => {
                                        if (isValidDate(e.target.value)) {
                                            const newTime = handleDateChange(e.target.value);
                                            dispatch(updateCampaignDayTime(field.dayOfWeek, newTime, 'end'));
                                        }
                                    }}
                                    placeholder="00:00"
                                    timeOnly
                                    hourFormat="24"
                                    onFocus={() => handleTimeFocus(field.dayOfWeek, 'end')}
                                    onBlur={() => handleTimeBlur(field.dayOfWeek, 'end')}
                                    onInput={(e: any) => {
                                        const input = e.target as HTMLInputElement;

                                        let digits = input.value.replace(/\D/g, "").slice(0, 4);
                                        const HH = digits.slice(0, 2);
                                        const MM = digits.slice(2, 4);

                                        const display = HH + (digits.length > 2 ? ":" + MM : "");

                                        if (input.value !== display) {
                                            const caret = digits.length + (digits.length > 2 ? 1 : 0);
                                            input.value = display;
                                            input.setSelectionRange(caret, caret);
                                        }

                                        if (digits.length === 4) {
                                            const h = parseInt(HH, 10);
                                            const m = parseInt(MM, 10);
                                            const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
                                            if (valid) {
                                                const dayData = updatedScheduler?.days?.find((day: any) => day.dayOfWeek === field.dayOfWeek);
                                                const base = dayData?.end ? new Date(dayData.end) : new Date();
                                                base.setHours(h, m, 0, 0);
                                                const newTime = handleDateChange(base);
                                                dispatch(updateCampaignDayTime(field.dayOfWeek, newTime, 'end'));
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="grid col-12 md:col-12 pt-0">
                {errorFields?.scheduler && <div className="col-12 md:col-12 p-0 m-0 pl-2 mb-2"><span className="title p-error text-sm">{errorFields?.scheduler?.scheduler}</span></div>}
            </div>
        </div>
    );
};

export default CampaignDaysWeekSchedule;
